export const Name = 'entityDataComponent';
